import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";

const PAGE_KEY = "/privacy-policy";

export const Route = createFileRoute("/privacy-policy")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: loaderData.title },
          { name: "description", content: loaderData.description },
          { property: "og:title", content: loaderData.title },
          { property: "og:description", content: loaderData.description },
      { property: "og:url", content: "https://www.phil-carr.co.uk/privacy-policy" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/privacy-policy" }],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage
      body={page.body}
      pageContext={page.title}
      showForm={false}
      relatedSlugs={[]}
      relatedTitle="Latest news"
      relatedEyebrow="From the blog"
      hideDecorativeShapes
      variant="legal"
    />
  );
}
